import tippy, { followCursor } from 'tippy.js';

const isDesktop = window.matchMedia('(min-width: 1172px)').matches;

tippy('[data-tippy-content]', {
	maxWidth: 645,
	allowHTML: true,
	followCursor: isDesktop ? true : 'initial',
	plugins: [followCursor],
});
